<template>
  <OffcanvasComponent
    :id="`offcanvas_views`"
    :title="title"
    @offcanvasClosed="offcanvasClosed"
  >
    <component :is="View" v-bind="viewProps" />
  </OffcanvasComponent>
</template>

<script setup lang="ts">
import { computed, type Component } from "vue";
import { useOffcanvasStore } from "@/store/useOffcanvasStore";
import { toggleOffcanvas } from "@/utils/Helper";
import { OffcanvasViewKey, Views } from "./OffcanvasViewsConfig";

const store = useOffcanvasStore();

const View = computed<Component | null>(
  () => Views[store.config?.path as OffcanvasViewKey] || null,
);
const viewProps = computed(() => store.config?.props ?? null);
const title = computed(() => store.config?.title ?? "");

function offcanvasClosed() {
  if (store.history.length === 1) {
    toggleOffcanvas("offcanvas_views");
    setTimeout(() => {
      store.clear();
      store.popHistory();
    }, 200);
  } else {
    store.popHistory();
  }
}
</script>
